function pluralize(word: string): string {
  if (/(?:s|x|z|ch|sh)$/i.test(word) || /[^aeiou]o$/i.test(word)) {
    return `${word}es`;
  }

  if (/[^aeiou]y$/i.test(word)) {
    return `${word.slice(0, -1)}ies`;
  }

  if (/[aeiou]y$/i.test(word)) {
    return `${word}s`;
  }

  if (/fe?$/i.test(word)) {
    return word.replace(/fe?$/i, 'ves');
  }

  return `${word}s`;
}

export function ToPlural(word: string, array: any[], customPlural?: string): string {
  if (!array || array.length === 0) {
    return `0 ${customPlural || pluralize(word)}`;
  }

  if (array.length === 1) {
    return `1 ${word}`;
  }

  const pluralForm = customPlural || pluralize(word);
  return `${array.length} ${pluralForm}`;
}
